import Vue from 'vue'
import Popper from '../base/popper'
import Locale from '../../mixins/locale'
import TPopperButton from './popper-button.vue'

const PREFIXCLS = 'popover'
function getComponentChild (children) {
  return children && children.filter(c => c && c.tag)
}

function clickOutSide (el, popper, cb) {
  function documentHandler (e) {
    if (el.contains(e.target) || (popper && popper.contains(e.target))) {
      return false
    }
    cb && cb(e)
  }
  document.addEventListener('click', documentHandler, false)
}

export default {
  name: 'TPoptip',
  mixins: [Popper, Locale],
  props: {
    trigger: {
      type: String,
      default: 'click',
      validator (value) {
        return ['click', 'focus', 'hover'].includes(value)
      }
    },
    placement: {
      type: String,
      default: 'top',
      validator (value) {
        return [
          'top',
          'top-start',
          'top-end',
          'bottom',
          'bottom-start',
          'bottom-end',
          'left',
          'left-start',
          'left-end',
          'right',
          'right-start',
          'right-end'
        ].includes(value)
      }
    },
    title: {
      type: [String, Number]
    },
    content: {
      type: [String, Number]
    },
    width: {
      type: [String, Number]
    },
    confirm: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String
    },
    cancelText: {
      type: String
    },
    tabable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS,
      showTitle: true,
      isInput: false,
      popperEl: null
    }
  },
  computed: {
    styles () {
      let style = {}

      if (this.width) {
        style.width = `${this.width}px`
      }
      return style
    },
    localeOkText () {
      if (this.okText === undefined) {
        return this.t('t.poptip.okText')
      } else {
        return this.okText
      }
    },
    localeCancelText () {
      if (this.cancelText === undefined) {
        return this.t('t.poptip.cancelText')
      } else {
        return this.cancelText
      }
    }
  },
  created () {
    let _this = this
    let instance = Vue.extend({
      components: { TPopperButton },
      data () {
        return {
          visible: _this.visible,
          styles: _this.styles,
          prefixCls: _this.prefixCls,
          title: _this.title,
          confirm: _this.confirm,
          localeCancelText: _this.localeCancelText,
          localeOkText: _this.localeOkText,
          showTitle: _this.showTitle,
          content: _this.content
        }
      },
      methods: {
        stopClick () {
          return false
        },
        onPopperConfirm () {
          _this.onPopperConfirm()
        },
        onPopperCancel () {
          _this.onPopperCancel()
        }
      },
      template: `
        <transition name="fade">
          <div v-show="visible" ref="popper" :class="['popover']" :style="styles" @click.stop="stopClick">
            <div :class="[prefixCls + '-arrow']"></div>
            <div :class="[prefixCls + '-content']">
              <h3 v-if="confirm&&title" :class="[prefixCls + '-title']" v-html="title"></h3>
              <div v-if="confirm" :class="[prefixCls + '-inner']">
                <div :class="[prefixCls + '-footer','text-right']">
                  <t-popper-button :locale-cancel-text="localeCancelText" :locale-ok-text="localeOkText" @on-popper-cancel="onPopperCancel" @on-popper-confirm="onPopperConfirm"></t-popper-button>
                </div>
                </div>
                <div v-if="!confirm" :class="[prefixCls + '-inner']">
                  <div v-if="showTitle" ref="title" :class="[prefixCls + '-title']">
                    <slot name="title">
                      <div :class="[prefixCls + '-title-inner']">{{ title }}</div>
                    </slot>
                  </div>
                  <div :class="[prefixCls + '-body']">
                    <div :class="[prefixCls + '-body-content']">
                      <slot name="content">
                        <div :class="[prefixCls + '-body-content-inner']">{{ content }}</div>
                      </slot>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </transition>
      `
    })

    this.popperEl = new instance()
    if (this.$slots.content) {
      this.popperEl.$slots.content = this.$slots.content
    }
    if (this.$slots.title) {
      this.popperEl.$slots.title = this.$slots.title
    }
    if (this.content || this.$slots.content || this.title || this.$slots.title) {
      this.popperEl.$mount()
    }
  },
  mounted () {
    if (this.popperEl) {
      this.$refs.popper = this.popperEl.$el
    }
    if (this.$slots.default && this.$slots.default[0] && this.$slots.default[0].tag) {
      this.$refs.reference = this.$slots.default[0].elm
    }
    if (this.$el.nodeType === 1 && this.tabable) {
    // 设置tab属性，使其能够根据tab来切换
      this.$el.setAttribute('tabindex', 0)
    }
    if (!this.confirm) {
      this.showTitle = this.$slots.title !== undefined || this.title
    }
    // if trigger and children is input or textarea,listen focus & blur event
    if (this.trigger === 'focus') {
      const $children = this.$_getInputChildren()
      if ($children) {
        $children.addEventListener('focus', this.onFocus, false)
        $children.addEventListener('blur', this.onBlur, false)
        this.isInput = true
      }
    }

    if (this.$refs.reference) {
      clickOutSide(this.$refs.reference, this.$refs.popper, this.onOutsideClick)
    }
  },
  watch: {
    visible (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'visible', val)
      }
    },
    styles (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'styles', val)
      }
    },
    prefixCls (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'prefixCls', val)
      }
    },
    title (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'title', val)
      }
    },
    confirm (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'confirm', val)
      }
    },
    localeCancelText (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'localeCancelText', val)
      }
    },
    localeOkText (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'localeOkText', val)
      }
    },
    showTitle (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'showTitle', val)
      }
    },
    content (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'content', val)
      }
    }
  },
  render (h) {
    // if (this.$slots.content) {
    //   this.popperEl.$slots.content = this.$slots.content
    // }
    // if (this.$slots.title) {
    //   this.popperEl.$slots.title = this.$slots.title
    // }
    this.$_attachPoper()
    if (!this.$slots.default || !this.$slots.default.length) return this.$slots.default
    const vnodeLength = getComponentChild(this.$slots.default).length
    let vnode = null
    if (vnodeLength === 1) {
      vnode = this.$slots.default[0]
    } else {
      vnode = h('div', {'class': {'d-inline-block': true}}, this.$slots.default)
    }
    if (!vnode) return vnode
    /**
     * vnode 对象参数（https://segmentfault.com/a/1190000008291645）
     */
    vnode.data = vnode.data || {}
    const on = vnode.data.on = vnode.data.on || {}
    const nativeOn = vnode.data.nativeOn = vnode.data.nativeOn || {}

    nativeOn.click = on.click = this.addEventHandle(on.click, this.onButtonClick)
    nativeOn.mouseenter = on.mouseenter = this.addEventHandle(on.mouseenter, this.onTriggerMouseenter)
    nativeOn.mouseleave = on.mouseleave = this.addEventHandle(on.mouseleave, this.onTriggerMouseleave)
    nativeOn.focus = on.focus = this.addEventHandle(on.focus, this.onPopperFocus)
    nativeOn.blur = on.blur = this.addEventHandle(on.blur, this.onPopperBlur)
    return vnode
  },
  methods: {
    $_attachPoper () {
      if (this.$slots.content && !this.content) {
        this.popperEl.$slots.content = this.$slots.content
      }
      if (this.$slots.title && !this.title) {
        this.popperEl.$slots.title = this.$slots.title
      }
      if ((this.$slots.content || this.content !== '') && !this.popperEl.$el) {
        this.popperEl.$mount()
        this.$refs.popper = this.popperEl.$el
      }
    },
    addEventHandle (old, fn) {
      if (!old) {
        return fn
      } else if (Array.isArray(old)) {
        return old.indexOf(fn) > -1 ? old : old.concat(fn)
      } else {
        return old === fn ? old : [old, fn]
      }
    },
    // 添加私有方法
    onButtonClick () {
      this.$_attachPoper()
      if (this.confirm) {
        this.visible = !this.visible
        return true
      }
      if (this.trigger !== 'click') {
        return false
      }
      this.visible = !this.visible
    },
    onOutsideClick (e) {
      if (this.confirm) {
        this.visible = false
        return true
      }
      if (this.trigger !== 'click') {
        return false
      }
      this.visible = false
    },
    onTriggerMouseenter () {
      this.$_attachPoper()
      if (this.trigger !== 'hover' || this.confirm) {
        return false
      }
      this.visible = true
    },
    onTriggerMouseleave () {
      if (this.trigger !== 'hover' || this.confirm) {
        return false
      }
      this.visible = false
    },
    $_getInputChildren () {
      let defaultSlot = this.$slots.default
      const $input = defaultSlot || defaultSlot.length ? defaultSlot[0].elm.querySelector('input') : null
      const $textarea = defaultSlot || defaultSlot.length ? defaultSlot[0].elm.querySelector('textarea') : null
      return $input || ($textarea || null)
    },
    onPopperFocus (e) {
      if (this.trigger !== 'focus' || this.confirm || this.isInput) {
        return false
      }
      this.visible = true
    },
    onPopperBlur (e) {
      if (this.trigger !== 'focus' || this.confirm || this.isInput) {
        return false
      }
      if (this.$refs.popper.contains(e.target)) {
        return false
      }
      this.visible = false
    },
    onPopperCancel () {
      this.visible = false
      this.$emit('on-cancel')
    },
    onPopperConfirm () {
      this.visible = false
      this.$emit('on-ok')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/poptip/poptip.js